import * as martinez from 'martinez-polygon-clipping';
import { createCirclePolygon, createRectPolygon, rotateGeometry } from './shapes.js';
export const createPD7HolePolygon = (hole)=>{
    const { $absCoords: { x, y }, primaryRadius, verticalCenterDistance, verticalRadius, diagonalCenterDistance, diagonalRadius, horizontalCenterDistance, horizontalRadius } = hole;
    const center = {
        x,
        y
    };
    const primaryCircle = {
        center,
        radius: primaryRadius
    };
    const verticalCircles = [
        -1,
        1
    ].map((direction)=>({
            center: {
                x,
                y: y + direction * verticalCenterDistance
            },
            radius: verticalRadius
        }));
    const diagonalCenterXYDistance = Math.sqrt(diagonalCenterDistance ** 2 / 2);
    const diagonalCircles = [
        [
            1,
            1
        ],
        [
            1,
            -1
        ],
        [
            -1,
            -1
        ],
        [
            -1,
            1
        ]
    ].map(([directionX, directionY])=>({
            center: {
                x: x + directionX * diagonalCenterXYDistance,
                y: y + directionY * diagonalCenterXYDistance
            },
            radius: diagonalRadius
        }));
    const horizontalCircles = [
        -1,
        1
    ].map((direction)=>({
            center: {
                x: x + direction * horizontalCenterDistance,
                y
            },
            radius: horizontalRadius
        }));
    const verticalRectangle = {
        center,
        width: 2 * verticalRadius,
        height: 2 * verticalCenterDistance
    };
    const horizontalRectangle = {
        center,
        width: 2 * horizontalCenterDistance,
        height: 2 * horizontalRadius
    };
    const diagonalRectangle = {
        center,
        width: 2 * diagonalCenterDistance,
        height: 2 * diagonalRadius
    };
    const primaryCirclePolygon = createCirclePolygon(primaryCircle);
    const smallCirclePolygons = [
        ...verticalCircles,
        ...diagonalCircles,
        ...horizontalCircles
    ].map((circle)=>createCirclePolygon(circle));
    const rectanglePolygons = [
        verticalRectangle,
        horizontalRectangle
    ].map((rectangle)=>createRectPolygon(rectangle));
    const diagonalRectanglePolygons = [
        rotateGeometry(createRectPolygon(diagonalRectangle), Math.PI / 4, diagonalRectangle.center),
        rotateGeometry(createRectPolygon(diagonalRectangle), -Math.PI / 4, diagonalRectangle.center)
    ];
    // Polygons must be joined in the correct order. The primary circle should be the first one, then the rectangles.
    // Small circles should be last. Otherwise union minght not work correctly. The `martinez-polygon-clipping` library
    // for some reason returns multiple polygons instead of a single one, when incorrect order is used, but it happens
    // only on small plates. Probably because the primary circle and small circles are not overlapping.
    const allPolygons = [
        primaryCirclePolygon,
        ...rectanglePolygons,
        ...diagonalRectanglePolygons,
        ...smallCirclePolygons
    ];
    return allPolygons.reduce(martinez.union);
};

//# sourceMappingURL=pd7-hole.js.map